import ar from '@/locales/ar';
import en from '@/locales/en';
export const locale = localStorage.getItem('lang') || 'ar';
export default {
    data() {
        return {
            locale,
			locales: { ar, en }
        }
    },

    methods: {
        $t(key, params = {}) {
            let keys = key.split('.');
            let value = this.locales[this.locale];
            for (let i = 0; i < keys.length; i++) {
                if (value[keys[i]]) {
                    value = value[keys[i]];
                } else {
                    return key;
                }
            }
            if (value.includes('{') && value.includes('}')) {
                for (let param in params) {
                    value = value.replace(`{${param}}`, params[param]);
                }
            }
            return value;	
        },

		changeLang() {
			localStorage.setItem('lang', this.locale === 'en' ? 'ar' : 'en');
			window.location.reload();
		},
    },

    created() {
        this.locale = localStorage.getItem('lang') || 'ar';
        this.$vuetify.rtl = this.locale === 'ar';
        document.documentElement.setAttribute('lang', this.locale);
        // document.documentElement.setAttribute('dir', this.locale === 'ar'? 'rtl' : 'ltr');
    }
}